import React, { PureComponent } from 'react';
import { I18n } from 'react-redux-i18n';
import onClickOutside from 'react-click-outside';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import ScrollComponent from '../../../../common/ScrollComponent';
import { REDUCER_NAME, removeHeadlineCode } from './reducer';

class RemoveHeadlinePopup extends PureComponent {
  handleClickOutside = () => {
    const { toggleShow } = this.props;
    toggleShow();
  };

  removeCode = code => {
    const { removeHeadlineCode } = this.props;
    removeHeadlineCode(code);
  };

  render() {
    const { headlineCodes } = this.props;

    return (
      <div className="remove-headline-popup">
        <div className="remove-headline-popup-title">
          {I18n.t('common.headline')}
        </div>
        <div className="remove-headline-popup-content">
          <ScrollComponent
            appendStyle={{
              maxHeight: 128,
            }}
          >
            {headlineCodes.map(item => (
              <div key={item.code} className="remove-headline-popup-item">
                <div>{item.displayCode}</div>
                {item.isTicker && (
                  <div
                    onClick={() => this.removeCode(item.code)}
                    className="remove"
                  >
                    <i className="icon-bin-delete" />
                  </div>
                )}
              </div>
            ))}
          </ScrollComponent>
        </div>
      </div>
    );
  }
}

RemoveHeadlinePopup.propTypes = {
  headlineCodes: PropTypes.array.isRequired,
  removeHeadlineCode: PropTypes.func.isRequired,
  toggleShow: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  headlineCodes: state[REDUCER_NAME].headlineCodes,
});

const mapDispatchToProps = {
  removeHeadlineCode,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  onClickOutside,
)(RemoveHeadlinePopup);
